import { lazy } from 'react';

export const PropertyInfoPageAsync = lazy(() => import('./PropertyInfoPage'));
